import styled from 'styled-components'
import { useState } from 'react'

import RadioButton from 'checkout/components/RadioButton'
import RadioGroup from 'checkout/components/RadioGroup'
import Spinner from 'shared/components/Spinner'
import { Button } from 'shared/components/Button'
import { CheckoutQA } from 'shared/dataAttributes'
import { FeatureFlag } from 'shared/enums/FeatureFlag'
import { colors, fonts } from 'shared/lib'
import { formatMoneyObject } from 'shared/lib/formatMoneyObject'
import { getShippingMethodText } from 'shared/utils/shipping-method-utils'
import { t } from 'localization'
import { useCheckoutContext } from 'checkout/containers/CheckoutContextProvider'
import { useFeatureFlag } from 'featureFlags/hooks/useFeatureFlag'

const TP = 'checkout.panels.ShippingMethod.ShippingMethodForm'

export const ShippingMethodForm = () => {
  const {
    order,
    changeShippingServiceLevelRTK,
    panels: { shippingMethod },
  } = useCheckoutContext()
  const isExposedPaymentMethods = useFeatureFlag(FeatureFlag.TEMP_WEB_FC_EXPOSED_PAYMENT_METHODS)
  const shippingServiceLevel = order?.shippingServiceLevel
  const initialShippingId = shippingServiceLevel ? shippingServiceLevel : 'standard'
  const [selectedMethodId, setSelectedMethodId] = useState(initialShippingId)

  return (
    <Spinner
      showSpinner={shippingMethod.loading}
      text={t(`${TP}.spinnerText`, 'Saving shipping method...')}
      subText={t(`${TP}.spinnerSubText`, 'Please do not close your browser!')}
    >
      <RadioGroup name="shippingMethod">
        {order?.shippingServiceLevelOptions.map(
          ({ available, description, id, localizedPriceCents, name }) => (
            <RadioButton
              checked={id === selectedMethodId}
              disabled={!available}
              displayRadioButton={isExposedPaymentMethods}
              key={id}
              marginBetween="10px 0"
              onRadioSelect={() => setSelectedMethodId(id)}
              qaAttr={`${CheckoutQA.ShippingMethod}`}
              subtitle={
                available ? (
                  <Subtitle>{description}</Subtitle>
                ) : (
                  <Subtitle>
                    {t(`${TP}.shippingMethodSubTitle`, 'Item not eligible for Next Day')}
                  </Subtitle>
                )
              }
              title={`${getShippingMethodText(name)} - ${
                available
                  ? formatMoneyObject(localizedPriceCents, { showCents: true })
                  : t(`${TP}.unavailable`, 'Unavailable')
              }`}
              value={id}
            />
          ),
        )}
      </RadioGroup>
      <Notice data-qa={CheckoutQA.ShippingMethodNoticeText}>
        {order?.shippingServiceLevel?.disclaimer}
      </Notice>
      <Button
        $fill
        buttonType="primary1"
        onClick={() => changeShippingServiceLevelRTK(selectedMethodId)}
        qaAttr={CheckoutQA.ShippingMethodContinueButton}
      >
        {t(`${TP}.continue`, 'Continue')}
      </Button>
    </Spinner>
  )
}

const Notice = styled.div`
  margin: 20px 0;
  ${fonts.BODY_TEXT}
`
const Subtitle = styled.div`
  ${fonts.BODY_TEXT}
  color: ${({ color }) => color || colors.FC2_GREY};
`
